 import React, { Component, useEffect } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import * as actions from '../../store/actions/index';
import { connect } from 'react-redux';
import Paper from '@material-ui/core/Paper';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import List from '@material-ui/core/List';
import { Document, Page, pdfjs } from 'react-pdf';
import SignatureCanvas from 'react-signature-canvas';
import { withRouter } from 'react-router-dom';
import Iframe from 'react-iframe'
import CircularProgress from '@material-ui/core/CircularProgress';
import ChatBoxAward from './ChatBox_award';
import ChatBoxAwardSalesOfGoods from './ChatBox_award_SalesOfGoods';
import ChatBoxAwardServiceDisputeChi from './ChatBox_award_ServiceDispute_chi';
import ChatBoxAwardServiceDispute from './ChatBox_award_ServiceDispute';
import ChatBoxAwardInsuranceDisputeChi from './ChatBox_award_InsuranceDispute_chi';
import ChatBoxAwardInsuranceDispute from './ChatBox_award_InsuranceDispute';
import ChatBoxAwardSalesOfGoodsChi from './ChatBox_award_SalesOfGoods_chi';
import ChatBoxAward_other from './ChatBox_award_other';
import ChatBoxAward_other_chi from './ChatBox_award_other_chi';
import ChatBoxAwardChi from './ChatBox_awardChi';
import ChatBox_award_creditcard from './ChatBox_award_creditcard';
import Card from '@material-ui/core/Card';
import CardMedia from '@material-ui/core/CardMedia';
import CardActions from '@material-ui/core/CardActions';
import Grid from '@material-ui/core/Grid';
import withSizes from 'react-sizes';
import ChatBoxAwardEstate from './ChatBoxAwardEstate';
import ChatBoxAwardEstate_chi from './ChatBoxAwardEstate_chi';
import axios from 'axios';
import SignatureCanvasWrapperArbitrator from '../Onboarding/SignatureCanvasWrapperArbitrator'
import PDF from '../Onboarding/PDF';
import ArbitratorAcceptRejectBox from '../NavTabs/ArbitratorAcceptRejectBox'
import UploadDocsSingleFile from '../Onboarding/UploadDocsSingleFile'
import leftIcon from '../../images/left.png'
import Button from "@material-ui/core/Button";
import PropTypes from "prop-types";
import ChatBox_award_ServiceDispute from './ChatBox_award_ServiceDispute';
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const styles = theme => ({
    textColor: {
        color: '#a52423'
    },
    divStyle: {
        // paddingLeft: '5%',
        // paddingTop: '30px',
        // paddingRight: '340px',
        // paddingBottom: '70px',
        // // border: 'none'
        // align:'center',
        // textAlign: 'center'
        width:'100vw'
    },
    padding: {
        // padding: '30px'
    },
    subText: {
        color: '#a52423',
    },
    container:{
        // marginLeft:'20%'
    },
    paper:{
        align:'center',
        textAlign: 'center',
        marginTop: '20vh',
        color:'#a52423'
    },
    paper:{
        align:'center',
        textAlign: 'center',
        marginTop: '2vh',
        color:'#a52423'
    },
    bInput: {
        background: "rgba(255, 255, 255, 0.5)",
        outline: "0",
        color: "#99192D",
        wordWrap: "break-word",
        wordBreak: "break-word",
        border: "2px solid #99192D",
        paddingTop: "15px",
        paddingBottom: "15px",
        borderRadius: "25px",
        // height: "30px",
        marginLeft: "3px",
        marginRight: "3px",
        textTransform: 'none',
        boxSizing: "border-box",
        fontSize: "16px",
        "&:hover": {
            color: "white",
        },
    }
});

class Award extends Component {

    state = {
        numPages: null,
        pageNumber: 1,
        typeOfAccount:localStorage.getItem('typeOfAccount'),
        isLoading: true,
    }

    onDocumentLoadSuccess = ({ numPages }) => {
        this.setState({ numPages });
    }

    openInNewWindow(){
        window.open(__dirname+'chatbot_response.html',"_self");
    }

    componentWillUpdate() {
    }



    componentDidMount() {
        this.checkLanguage()
        setTimeout(()=>{
            this.setState({
                isLoading: false
            })
        },10000)

        if (this.state.typeOfAccount == 'arbitrator' || this.state.typeOfAccount == 'admin'){
            let url = `${process.env.REACT_APP_SERVER_HOSTNAME}:${process.env.REACT_APP_SERVER_PORT}/awardChatbotStatus`;
            let payload = {
                caseId: this.props.caseId,
                status: 'add'
            }
            
            axios.post(url, payload)
            .then((response) => {
                console.log('add award: '+JSON.stringify(response))
                if(response.data === 'added'){
                    setInterval(()=>{
                        let url2 = `${process.env.REACT_APP_SERVER_HOSTNAME}:${process.env.REACT_APP_SERVER_PORT}/awardChatbotStatus`;
                        let payload2 = {
                            caseId: this.props.caseId,
                            status: 'check'
                        }
                        
                        axios.post(url2, payload2)
                        .then((response2) => {
                            // console.log('check response: '+JSON.stringify(response2))
                            if(response2.data === 1){
    
                                let url3 = `${process.env.REACT_APP_SERVER_HOSTNAME}:${process.env.REACT_APP_SERVER_PORT}/awardChatbotStatus`;
                                let payload3 = {
                                    caseId: this.props.caseId,
                                    status: 'delete'
                                }
                                
                                axios.post(url3, payload3)
                                .then((response3) => {
                                    console.log('delete response: '+JSON.stringify(response3))
                                    if(response3.data === 'deleted'){
                                        window.location.reload()
                                    }
                                })
                                .catch((err)=>{
                                    console.log('awardChatbotStatus err:'+err)
                                })
                            }
                        })
                        .catch((err)=>{
                            console.log('awardChatbotStatus err:'+err)
                        })
                    },2000)
                }
            })
            .catch((err)=>{
                console.log('awardChatbotStatus err:'+err)
            })
        }
    }
    handleReopenAward = () => {
        let url = `${process.env.REACT_APP_SERVER_HOSTNAME}:${process.env.REACT_APP_SERVER_PORT}/setAwardDelivered`;
        let payload = {
            caseId: this.props.caseData.caseId,
            awardDelivered: 'waiting'
        };
        axios.post(url, payload)
            .then((response) => {
                console.log('reopen award response: ' + JSON.stringify(response));
                window.location.reload();
            })
            .catch((err) => {
                console.log('reopen award err: ' + err);
            });
    }

    handleCloseAward = () => {
        let url = `${process.env.REACT_APP_SERVER_HOSTNAME}:${process.env.REACT_APP_SERVER_PORT}/setAwardDelivered`;
        let payload = {
            caseId: this.props.caseData.caseId,
            awardDelivered: true
        };
        axios.post(url, payload)
            .then((response) => {
                console.log('close award response: ' + JSON.stringify(response));
                window.location.reload();
            })
            .catch((err) => {
                console.log('close award err: ' + err);
            });
    }

    checkLanguage = function() {
        try{
          if (this.props.isLoading){
            setTimeout(()=>{this.checkLanguage()},100)
          }
          else{
            console.log('this caseData: '+JSON.stringify(this.props.caseData))
            var lang = localStorage.getItem('language');
            if (this.props !== undefined){
              if (this.props.caseData !== undefined){
                if (this.props.caseData.language !== undefined){
                  if (this.props.caseData.language == 'Chi'){
                    if (lang == 'en' || lang == undefined){
                      localStorage.setItem('language', 'cn');
                      setTimeout(()=>{
                          window.location.reload();
                      },100)
                    }
                  }
                  else if (this.props.caseData.language == 'Eng'){
                    if (lang == 'cn' || lang == undefined){
                      localStorage.setItem('language', 'en');
                      setTimeout(()=>{
                          window.location.reload();
                      },100)
                    }
                  }
                }
              }
            }
          }
        }catch(err){
          setTimeout(()=>{this.checkLanguage()},100)
        }
      }
    render() {
        const { classes, file, award } = this.props;
        let { numPages, pageNumber } = this.state;
        console.log(`this.props.loadingCaseInfo ${award}`)
        console.log(this.props.loadingCaseInfo)
        if(this.state.isLoading){
            console.log('AN loadingCaseInfo')
            return(
                <CircularProgress size={50} thickness={3} className={classes.progress}/>
            );
        }
        else{
            console.log('this.props.caseData: '+this.props.caseData)
            
            let fileURLNoName = `${process.env.REACT_APP_SERVER_HOSTNAME}:9000/getPdf/?id=${this.props.conversationId}_award`;
            let fileURL = `${process.env.REACT_APP_SERVER_HOSTNAME}:9000/getPdfwithName/?id=${this.props.conversationId}_award`;
            let fileDocURL = `${process.env.REACT_APP_SERVER_HOSTNAME}:9000/getDoc/?id=${this.props.conversationId}_award`;
            console.log('fileURLNoName: '+fileURLNoName+' fileURL: '+fileURL+' fileDocURL: '+fileDocURL+ ' this.props.caseData.award: '+JSON.stringify(this.props.caseData.award) +' this.props.caseData.awardDelivered: '+this.props.caseData.awardDelivered)

            if (this.props.caseData.award){
                if (this.props.caseData.awardDelivered == undefined){
                    console.log('123e1313qe1')
                    // show sign pad
                    return (
                        <div className={classes.divStyle} style={{ marginBottom:'40%' }}>
                            <Button onClick={(e)=>{this.props.handleChange(e, undefined)}} style={{textAlign:'left'}}><img style={{width:'15%', marginRight:'10px'}} src={leftIcon}></img>{this.context.t("Back")}</Button>
                            {/* <UploadDocsSingleFile/> */}
                            <SignatureCanvasWrapperArbitrator file={fileURL} fileURLNoName={fileURLNoName} conversationId={this.props.caseData.conversationId}/>
                        </div>
                    );
                }
                else if (this.props.caseData.awardDelivered == false){
                    console.log('123e1313qe2')
                    // show sign pad
                    return (
                        <div className={classes.divStyle} style={{ marginBottom:'40%' }}>
                            <Button onClick={(e)=>{this.props.handleChange(e, undefined)}} style={{textAlign:'left'}}><img style={{width:'15%', marginRight:'10px'}} src={leftIcon}></img>{this.context.t("Back")}</Button>
                            {/* <UploadDocsSingleFile/> */}
                            <SignatureCanvasWrapperArbitrator file={fileURL} fileURLNoName={fileURLNoName} conversationId={this.props.caseData.conversationId}/>
                        </div>
                    );
                }
                else if (this.props.caseData.awardDelivered == 'waiting'){
                    if (this.state.typeOfAccount == 'admin'){
                        console.log('123eqe')
                        return (
                            <div style={{ marginBottom:'40%' }}>
                                <Button onClick={(e)=>{this.props.handleChange(e, undefined)}} style={{textAlign:'left'}}><img style={{width:'15%', marginRight:'10px'}} src={leftIcon}></img>{this.context.t("Back")}</Button>
                                <PDF caseId={this.props.caseData.caseId} setRelease={this.props.setRelease} isDesktop={this.props.isMobile} file={fileURL} fileURLNoName={fileURLNoName} isAward={true} wordFile={fileDocURL} isAdmin={true}></PDF>
                                {/* <div style={{display:'flex', justifyContent:'center', marginTop:'20px'}}>
                                    <Button className={classes.bInput} onClick={this.handleCloseAward} variant="contained" color="primary">{this.context.t("Close Award")}</Button>
                                </div> */}
                            </div>
                        );
                    }
                    else if (this.state.typeOfAccount == 'arbitrator'){
                        return(
                            <div className={classes.divStyle} style={{ marginBottom:'40%' }}>
                                <Button onClick={(e)=>{this.props.handleChange(e, undefined)}} style={{textAlign:'left'}}><img style={{width:'15%', marginRight:'10px'}} src={leftIcon}></img>{this.context.t("Back")}</Button>
                                {/* <UploadDocsSingleFile/> */}
                                <SignatureCanvasWrapperArbitrator file={fileURL} fileURLNoName={fileURLNoName} conversationId={this.props.caseData.conversationId}/>
                            </div>
                        );
                    }
                }
                else if (this.props.caseData.awardDelivered == true){
                    if (this.state.typeOfAccount == 'arbitrator'){
                        console.log('123eqe22')
                        return (
                            <div className={classes.divStyle} style={{ marginBottom:'40%' }}>
                                <Button onClick={(e)=>{this.props.handleChange(e, undefined)}} style={{textAlign:'left'}}><img style={{width:'15%', marginRight:'10px'}} src={leftIcon}></img>{this.context.t("Back")}</Button>
                                <PDF caseId={this.props.caseData.caseId} setRelease={this.props.setRelease} isDesktop={this.props.isMobile} file={fileURL} fileURLNoName={fileURLNoName} isAward={true} wordFile={fileDocURL} isAdmin={true}></PDF>
                            </div>
                        );
                    }
                    else if (this.state.typeOfAccount == 'admin'){
                        console.log('2342eqe admin')
                        return (
                            <div className={classes.divStyle} style={{ marginBottom:'40%' }}>
                                <Button onClick={(e)=>{this.props.handleChange(e, undefined)}} style={{textAlign:'left'}}><img style={{width:'15%', marginRight:'10px'}} src={leftIcon}></img>{this.context.t("Back")}</Button>
                                <PDF caseId={this.props.caseData.caseId} setRelease={this.props.setRelease} isDesktop={this.props.isMobile} file={fileURL} fileURLNoName={fileURLNoName} isAward={true} wordFile={fileDocURL} isAdmin={true}></PDF>

                                {/* <div style={{display:'flex', justifyContent:'center', marginTop:'20px'}}>
                                    <Button className={classes.bInput} onClick={this.handleReopenAward} variant="contained" color="secondary">{this.context.t("Reopen Award")}</Button>
                                </div> */}
                            </div>
                        );
                    }
                    else{
                        console.log('2342eqe')
                        return (
                            <div className={classes.divStyle} style={{ marginBottom:'40%' }}>
                                <Button onClick={(e)=>{this.props.handleChange(e, undefined)}} style={{textAlign:'left'}}><img style={{width:'15%', marginRight:'10px'}} src={leftIcon}></img>{this.context.t("Back")}</Button>
                                <PDF caseId={this.props.caseData.caseId} setRelease={this.props.setRelease} isDesktop={this.props.isMobile} file={fileURL} fileURLNoName={fileURLNoName} isAdmin={false}></PDF>
                            </div>
                        );
                    }
                }
                
            }
            else{
                if (this.state.typeOfAccount == 'arbitrator'){
                    console.log('Award: arbitrator caseDate a1: '+this.props.caseData.kind_of_claim);
                    console.log('Award: arbitrator (this.props.caseData.arbitratorStatus: '+(this.props.caseData.arbitratorStatus));
                    if (this.props.caseData.arbitratorStatus == 'true'){
                        if (this.props.caseData.kind_of_claim == 'estate_agent_dispute_seperate_agent'){
                            if (this.props.caseData.language == 'Eng'){
                                return (
                                    <div className={classes.container}>
                                        <Button onClick={(e)=>{this.props.handleChange(e, undefined)}} style={{textAlign:'left'}}><img style={{width:'15%', marginRight:'10px'}} src={leftIcon}></img>{this.context.t("Back")}</Button>
                                        <ChatBoxAwardEstate isDesktop={this.props.isDesktop} caseId={this.props.caseId}/>
                                    </div>
                                );
                            }
                            else if (this.props.caseData.language == 'Chi'){
                                return (
                                    <div className={classes.container}>
                                        <Button onClick={(e)=>{this.props.handleChange(e, undefined)}} style={{textAlign:'left'}}><img style={{width:'15%', marginRight:'10px'}} src={leftIcon}></img>{this.context.t("Back")}</Button>
                                        <ChatBoxAwardEstate_chi isDesktop={this.props.isDesktop} caseId={this.props.caseId}/>
                                    </div>
                                );
                            }
                        }
                        else if (this.props.caseData.kind_of_claim == 'money_lent'){
                            if (this.props.caseData.language == 'Eng'){
                                return (
                                    <div className={classes.container}>
                                        <Button onClick={(e)=>{this.props.handleChange(e, undefined)}} style={{textAlign:'left'}}><img style={{width:'15%', marginRight:'10px'}} src={leftIcon}></img>{this.context.t("Back")}</Button>
                                        <ChatBoxAward isDesktop={this.props.isDesktop} caseId={this.props.caseId}/>
                                    </div>
                                );
                            }
                            else if (this.props.caseData.language == 'Chi'){
                                return (
                                    <div className={classes.container}>
                                        <Button onClick={(e)=>{this.props.handleChange(e, undefined)}} style={{textAlign:'left'}}><img style={{width:'15%', marginRight:'10px'}} src={leftIcon}></img>{this.context.t("Back")}</Button>
                                        <ChatBoxAwardChi isDesktop={this.props.isDesktop} caseId={this.props.caseId}/>
                                    </div>
                                );
                            }
                        }
                        else if (this.props.caseData.kind_of_claim == 'creditcard'){
                            if (this.props.caseData.language == 'Eng'){
                                return (
                                    <div className={classes.container}>
                                        <Button onClick={(e)=>{this.props.handleChange(e, undefined)}} style={{textAlign:'left'}}><img style={{width:'15%', marginRight:'10px'}} src={leftIcon}></img>{this.context.t("Back")}</Button>
                                        <ChatBox_award_creditcard isDesktop={this.props.isDesktop} caseId={this.props.caseId}/>
                                    </div>
                                );
                            }
                            else if (this.props.caseData.language == 'Chi'){
                                return (
                                    <div className={classes.container}>
                                        <Button onClick={(e)=>{this.props.handleChange(e, undefined)}} style={{textAlign:'left'}}><img style={{width:'15%', marginRight:'10px'}} src={leftIcon}></img>{this.context.t("Back")}</Button>
                                        <ChatBoxAwardChi isDesktop={this.props.isDesktop} caseId={this.props.caseId}/>
                                    </div>
                                );
                            }
                        }
                        else if (this.props.caseData.kind_of_claim == 'other_dispute'){
                            if (this.props.caseData.language == 'Eng'){
                                return (
                                    <div className={classes.container}>
                                        <Button onClick={(e)=>{this.props.handleChange(e, undefined)}} style={{textAlign:'left'}}><img style={{width:'15%', marginRight:'10px'}} src={leftIcon}></img>{this.context.t("Back")}</Button>
                                        <ChatBoxAward_other isDesktop={this.props.isDesktop} caseId={this.props.caseId}/>
                                    </div>
                                );
                            }
                            else if (this.props.caseData.language == 'Chi'){
                                return (
                                    <div className={classes.container}>
                                        <Button onClick={(e)=>{this.props.handleChange(e, undefined)}} style={{textAlign:'left'}}><img style={{width:'15%', marginRight:'10px'}} src={leftIcon}></img>{this.context.t("Back")}</Button>
                                        <ChatBoxAward_other_chi isDesktop={this.props.isDesktop} caseId={this.props.caseId}/>
                                    </div>
                                );
                            }
                        }
                        else if (this.props.caseData.kind_of_claim == 'SalesOfGoods'){
                            if (this.props.caseData.language == 'Eng'){
                                return (
                                    <div className={classes.container}>
                                        <Button onClick={(e)=>{this.props.handleChange(e, undefined)}} style={{textAlign:'left'}}><img style={{width:'15%', marginRight:'10px'}} src={leftIcon}></img>{this.context.t("Back")}</Button>
                                        <ChatBoxAwardSalesOfGoods isDesktop={this.props.isDesktop} caseId={this.props.caseId}/>
                                    </div>
                                );
                            }
                            else if (this.props.caseData.language == 'Chi'){
                                return (
                                    <div className={classes.container}>
                                        <Button onClick={(e)=>{this.props.handleChange(e, undefined)}} style={{textAlign:'left'}}><img style={{width:'15%', marginRight:'10px'}} src={leftIcon}></img>{this.context.t("Back")}</Button>
                                        <ChatBoxAwardSalesOfGoodsChi isDesktop={this.props.isDesktop} caseId={this.props.caseId}/>
                                    </div>
                                );
                            }
                        }
                        else if (this.props.caseData.kind_of_claim == 'serviceDispute'){
                            if (this.props.caseData.language == 'Eng'){
                                return (
                                    <div className={classes.container}>
                                        <Button onClick={(e)=>{this.props.handleChange(e, undefined)}} style={{textAlign:'left'}}><img style={{width:'15%', marginRight:'10px'}} src={leftIcon}></img>{this.context.t("Back")}</Button>
                                        <ChatBoxAwardServiceDispute isDesktop={this.props.isDesktop} caseId={this.props.caseId}/>
                                    </div>
                                );
                            }
                            else if (this.props.caseData.language == 'Chi'){
                                return (
                                    <div className={classes.container}>
                                        <Button onClick={(e)=>{this.props.handleChange(e, undefined)}} style={{textAlign:'left'}}><img style={{width:'15%', marginRight:'10px'}} src={leftIcon}></img>{this.context.t("Back")}</Button>
                                        <ChatBoxAwardServiceDisputeChi isDesktop={this.props.isDesktop} caseId={this.props.caseId}/>
                                    </div>
                                );
                            }
                        }
                        else if (this.props.caseData.kind_of_claim == 'insuranceDispute'){
                            if (this.props.caseData.language == 'Eng'){
                                return (
                                    <div className={classes.container}>
                                        <Button onClick={(e)=>{this.props.handleChange(e, undefined)}} style={{textAlign:'left'}}><img style={{width:'15%', marginRight:'10px'}} src={leftIcon}></img>{this.context.t("Back")}</Button>
                                        <ChatBoxAwardInsuranceDispute isDesktop={this.props.isDesktop} caseId={this.props.caseId}/>
                                    </div>
                                );
                            }
                            else if (this.props.caseData.language == 'Chi'){
                                return (
                                    <div className={classes.container}>
                                        <Button onClick={(e)=>{this.props.handleChange(e, undefined)}} style={{textAlign:'left'}}><img style={{width:'15%', marginRight:'10px'}} src={leftIcon}></img>{this.context.t("Back")}</Button>
                                        <ChatBoxAwardInsuranceDisputeChi isDesktop={this.props.isDesktop} caseId={this.props.caseId}/>
                                    </div>
                                );
                            }
                        }
                    }
                    else if (this.props.caseData.arbitratorStatus == 'waiting'){
                        return (
                            <div>
                                <Button onClick={(e)=>{this.props.handleChange(e, undefined)}} style={{textAlign:'left'}}><img style={{width:'15%', marginRight:'10px'}} src={leftIcon}></img>{this.context.t("Back")}</Button>
                                <ArbitratorAcceptRejectBox/>
                            </div>
                        );
                    }
                    else if (this.props.caseData.arbitratorStatus == 'false'){
                        return (
                            <div className={classes.divStyle}>
                                <Button onClick={(e)=>{this.props.handleChange(e, undefined)}} style={{textAlign:'left'}}><img style={{width:'15%', marginRight:'10px'}} src={leftIcon}></img>{this.context.t("Back")}</Button>
                            <h4 className={classes.paper}> {this.context.t('The arbitrator has rejected the case.')} </h4>
                            </div>
                        );
                    }
                }
                else if (this.state.typeOfAccount == 'admin'){
                    console.log('Award: admin caseDate a1: '+this.props.caseData.a1);
                    
                    if (this.props.caseData.kind_of_claim == 'estate_agent_dispute_seperate_agent'){
                        if (this.props.caseData.language == 'Eng'){
                            return (
                                <div className={classes.container}>
                                    <Button onClick={(e)=>{this.props.handleChange(e, undefined)}} style={{textAlign:'left'}}><img style={{width:'15%', marginRight:'10px'}} src={leftIcon}></img>{this.context.t("Back")}</Button>
                                    <ChatBoxAwardEstate isDesktop={this.props.isDesktop} caseId={this.props.caseId}/>
                                </div>
                            );
                        }
                        else if (this.props.caseData.language == 'Chi'){
                            return (
                                <div className={classes.container}>
                                    <Button onClick={(e)=>{this.props.handleChange(e, undefined)}} style={{textAlign:'left'}}><img style={{width:'15%', marginRight:'10px'}} src={leftIcon}></img>{this.context.t("Back")}</Button>
                                    <ChatBoxAwardEstate_chi isDesktop={this.props.isDesktop} caseId={this.props.caseId}/>
                                </div>
                            );
                        }
                    }
                    else if (this.props.caseData.kind_of_claim == 'money_lent'){
                        if (this.props.caseData.language == 'Eng'){
                            return (
                                <div className={classes.container}>
                                    <Button onClick={(e)=>{this.props.handleChange(e, undefined)}} style={{textAlign:'left'}}><img style={{width:'15%', marginRight:'10px'}} src={leftIcon}></img>{this.context.t("Back")}</Button>
                                    <ChatBoxAward isDesktop={this.props.isDesktop} caseId={this.props.caseId}/>
                                </div>
                            );
                        }
                        else if (this.props.caseData.language == 'Chi'){
                            return (
                                <div className={classes.container}>
                                    <Button onClick={(e)=>{this.props.handleChange(e, undefined)}} style={{textAlign:'left'}}><img style={{width:'15%', marginRight:'10px'}} src={leftIcon}></img>{this.context.t("Back")}</Button>
                                    <ChatBoxAwardChi isDesktop={this.props.isDesktop} caseId={this.props.caseId}/>
                                </div>
                            );
                        }
                    }
                    else if (this.props.caseData.kind_of_claim == 'creditcard'){
                        if (this.props.caseData.language == 'Eng'){
                            return (
                                <div className={classes.container}>
                                    <Button onClick={(e)=>{this.props.handleChange(e, undefined)}} style={{textAlign:'left'}}><img style={{width:'15%', marginRight:'10px'}} src={leftIcon}></img>{this.context.t("Back")}</Button>
                                    <ChatBoxAward isDesktop={this.props.isDesktop} caseId={this.props.caseId}/>
                                </div>
                            );
                        }
                        else if (this.props.caseData.language == 'Chi'){
                            return (
                                <div className={classes.container}>
                                    <Button onClick={(e)=>{this.props.handleChange(e, undefined)}} style={{textAlign:'left'}}><img style={{width:'15%', marginRight:'10px'}} src={leftIcon}></img>{this.context.t("Back")}</Button>
                                    <ChatBoxAwardChi isDesktop={this.props.isDesktop} caseId={this.props.caseId}/>
                                </div>
                            );
                        }
                    }
                    else if (this.props.caseData.kind_of_claim == 'other_dispute'){
                        if (this.props.caseData.language == 'Eng'){
                            return (
                                <div className={classes.container}>
                                    <Button onClick={(e)=>{this.props.handleChange(e, undefined)}} style={{textAlign:'left'}}><img style={{width:'15%', marginRight:'10px'}} src={leftIcon}></img>{this.context.t("Back")}</Button>
                                    <ChatBoxAward_other isDesktop={this.props.isDesktop} caseId={this.props.caseId}/>
                                </div>
                            );
                        }
                        else if (this.props.caseData.language == 'Chi'){
                            return (
                                <div className={classes.container}>
                                    <Button onClick={(e)=>{this.props.handleChange(e, undefined)}} style={{textAlign:'left'}}><img style={{width:'15%', marginRight:'10px'}} src={leftIcon}></img>{this.context.t("Back")}</Button>
                                    <ChatBoxAward_other_chi isDesktop={this.props.isDesktop} caseId={this.props.caseId}/>
                                </div>
                            );
                        }
                    }
                    else if (this.props.caseData.kind_of_claim == 'SalesOfGoods' || this.props.caseData.kind_of_claim == 'serviceDispute' || this.props.caseData.kind_of_claim == 'insuranceDispute'){
                        if (this.props.caseData.language == 'Eng'){
                            return (
                                <div className={classes.container}>
                                    <Button onClick={(e)=>{this.props.handleChange(e, undefined)}} style={{textAlign:'left'}}><img style={{width:'15%', marginRight:'10px'}} src={leftIcon}></img>{this.context.t("Back")}</Button>
                                    <ChatBoxAwardSalesOfGoods isDesktop={this.props.isDesktop} caseId={this.props.caseId}/>
                                </div>
                            );
                        }
                        else if (this.props.caseData.language == 'Chi'){
                            return (
                                <div className={classes.container}>
                                    <Button onClick={(e)=>{this.props.handleChange(e, undefined)}} style={{textAlign:'left'}}><img style={{width:'15%', marginRight:'10px'}} src={leftIcon}></img>{this.context.t("Back")}</Button>
                                    <ChatBoxAwardSalesOfGoodsChi isDesktop={this.props.isDesktop} caseId={this.props.caseId}/>
                                </div>
                            );
                        }
                    }
                }
                else if (this.state.typeOfAccount == 'user' || this.state.typeOfAccount == 'claimant' || this.state.typeOfAccount == 'respondent'){
                    return (
                        <div className={classes.divStyle}>
                            <Button onClick={(e)=>{this.props.handleChange(e, undefined)}} style={{textAlign:'left'}}><img style={{width:'15%', marginRight:'10px'}} src={leftIcon}></img>{this.context.t("Back")}</Button>
                        <h4 className={classes.paper}> {this.context.t('The Arbitrator has not delivered the Award yet.')} </h4>
                        </div>
                    );
                }
            }
        }
        return null;
    }
}

const mapStateToProps = (state) => {
    // console.log('mapStateToProps: state: ' + JSON.stringify(state));
    return {
        respondent_steps_completed: state.caseInfo.respondent_steps_completed,
        error: state.caseInfo.error,
        conversationId: state.caseInfo.conversationId,
        caseId: state.caseInfo.caseId,
        award: state.caseInfo.award,
        caseData: state.caseInfo.caseData,
        loadingCaseInfo: state.caseInfo.loading,
        // typeOfAccount: (state.auth.typeOfAccount !== undefined ? state.auth.typeOfAccount : state.userInfo.typeOfAccount),
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        getCaseInfo: (caseId) => dispatch(actions.getCaseInfo(caseId)),
        setRelease: (caseId) => dispatch(actions.setRelease(caseId)),
    }
}

const mapSizesToProps = sizes => ({
    isMobile: withSizes.isMobile(sizes),
    isTablet : withSizes.isTablet(sizes),
    isDesktop : withSizes.isDesktop(sizes),
    isGtMobile : withSizes.isGtMobile(sizes),
    isGtTablet : withSizes.isGtTablet(sizes),
    isStTablet : withSizes.isStTablet(sizes),
    isStDesktop : withSizes.isStDesktop(sizes),
    isTabletAndGreater : withSizes.isTabletAndGreater(sizes),
    isTabletAndSmaller : withSizes.isTabletAndSmaller(sizes),

})

Award.contextTypes = {
    t: PropTypes.func
}

export default connect(mapStateToProps, mapDispatchToProps)( withSizes(mapSizesToProps) (withStyles(styles)(withRouter(Award))) );
                